import React from 'react';
import './index.less';

export default ({ label }: { label: string }) => {
    return (
        <div className="detailTitle">
            <b />
            <div>{label}</div>
        </div>
    );
};
